import { api } from './client';
import type { PayoutSlot } from '@/lib/payouts';

export type LeaderboardRow = {
  rank: number;
  userId: number;
  displayName: string;
  score: number | null;
  entryId: number | null;
  paying: boolean;
  tied: boolean;
};

export type PendingRow = {
  userId: number;
  displayName: string;
  entryNumber: number;
  submittedAt: string | null;
};

export type LeaderboardPayout = {
  place: number;
  userId: number;
  userDisplayName: string | null;
  amountCents: number;
  paid: boolean;
};

export type LeaderboardSnapshot = {
  tournament: {
    id: number;
    name: string;
    status: 'setup' | 'active' | 'completed' | 'archived';
    machineName: string;
    payingPlaces: number;
    entryFeeCents: number;
    payoutStructure: PayoutSlot[];
  };
  ranked: LeaderboardRow[];
  pending: PendingRow[];
  potCents: number;
  totalEntries: number;
  payouts: LeaderboardPayout[];
  frozen: boolean;
};

export const leaderboardApi = {
  get: (id: number) =>
    api.get<LeaderboardSnapshot>(`/api/tournaments/${id}/leaderboard`),
};
